import api from 'managers/apiManager';
import { apiUsersUrls } from 'config/endPoints';

export const handleProfileCheck = (id) => {
    api
        .get(apiUsersUrls.API_WHOAMI_URL)
        .then((response) => {
        })
        .catch(function (error) {
        });
};